import { useQuery } from '@tanstack/react-query';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';

export interface FertilizerPack {
	_id: string;
	name: string;
	userId?: string;
	mix?: string | null;
	N?: string | null;
	P2O5?: string | null;
	K2O?: string | null;
	Ca?: string | null;
	Mg?: string | null;
	S?: string | null;
	B?: string | null;
	Zn?: string | null;
	Cu?: string | null;
	Mn?: string | null;
	Fe?: string | null;
}

interface PaginatedPacks {
	docs: FertilizerPack[];
	totalDocs: number;
}

export function useGetFertilizerPacks() {
	const forBinding = useForBindingId();

	return useQuery({
		queryKey: ['fertilizer-packs', forBinding],
		queryFn: async () => {
			const { data } = await api.get<PaginatedPacks | FertilizerPack[]>(
				'/advices/fertilizer-pack/findAll',
				{ params: { forBinding, limit: 200, page: 1 } }
			);
			if (Array.isArray(data)) return data;
			return data?.docs ?? [];
		},
	});
}
